<template>
  <div :class="getWrapperClass()">
   <label v-if="label" class="data-label" :class="{ regular: regularLabel }">
      {{ label }}
    </label>
    <div class="position-relative">
      <textarea
        :rows="rows"
        class="form-control"
        :id="id"
        :value="value"
        @input="$emit('input', $event.target.value)"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :disabled="disabled"
        :class="{ 'was-Invalidated': error }"/>
      <i v-if="error"
         class="fa fa-times-circle form-control-icon-invalid"></i>
      <span class="char-count"
            v-if="showCharCount"
            :class="getCountClasses()">
        <span v-if="maxlength > 0 && value">{{ value.length }}</span>
        <span v-else>0</span>
        de {{ maxlength }}
      </span>
    </div>
    <error v-if="error"
           variant="no-border"
           :message="customErrorMsg"/>
  </div>
</template>

<script>
import Error from "@/components/common/Error";

export default {
  name: "CustomTextArea",
   meta: {
    description: 'Componente para entrada de texto multilínea',
    slots: {
      default: {
        type: 'component',
        valid: [],
      }
    },
  },
  components: {
    Error
  },
  props: {
    id: {
      type: String,
      default: '',
      meta: {
        description: 'Id del Componente CustomTextArea',
        example: 'idCustomTextArea',
      }
    },
    label: {
      type: String,
      default: "",
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      }
    },
    classes: {
      type: Array,
      default: () => new Array(),
      meta: {
        description: 'Propiedad para almacenar caracteres',
        example: '4, 8, 15',
      }
    },
    countClasses: {
      type: Array,
      default: () => new Array(),
      meta: {
        description: 'Conteo de caracteres',
        example: '16, 23, 42',
      }
    },
    value: {
      type: String,
      default: '',
      meta: {
        description: 'Parámetro de entrada en el textarea',
        example: 'Texto requerido',
      }
    },
    maxlength: {
      type: Number,
      default: 0,
      required: true,
      meta: {
        description: 'Logitud máxima requerida',
        example: 'Texto requerido',
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      }
    },
    error: {
      type: String,
      default: "",
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      }
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      }
    },
    placeholder: {
      type: String,
      default: "",
      meta: {
        description: 'Texto de referencia en el textarea',
        example: 'Texto requerido',
      }
    },
    invalid: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Propiedad para validar',
        example: 'true',
      }
    },
    rows: {
      type: Number,
      default: 0,
      required: false,
      meta: {
        description: 'Especifica el número de líneas de texto visibles',
        example: '100',
      }
    },
    showCharCount: {
      type: Boolean,
      default: () => false
    },
    regularLabel: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Control para mostrar texto en regular',
        example: 'true'
      }
    }
  },
  data() {
    return {
      currentValue: ""
    };
  },
  mounted() {
    this.currentValue = this.value;
  },
  methods: {
    getWrapperClass: function() {
      return this.getClasses(this.classes);
    },
    getCountClasses: function() {
      return this.getClasses(this.countClasses);
    },
    getClasses: function(values) {
      return values.map(element => {
        return { [element]: true };
      });
    },
    updateValue: function(value) {
      this.$emit("input", value);
    }
  }
};
</script>
<style scoped>
textarea {
  background: #ffffff 0% 0% no-repeat padding-box;
  min-height: 100px;
}
span.invalid:not(input) {
  color: #e85c5c;
}
.regular {
  font-weight: 400;
}
textarea:disabled {
    background: #f8f8f8;
  }
textarea::placeholder {
  text-align: left;
  font: Regular 16px/20px Lato;
  letter-spacing: 0;
  color: #828d99;
  opacity: 1;
}
.form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #c5cdcf;
  opacity: 1;
}
.form-control-icon-invalid {
  color: #e85c5c;
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 19px;
}
.char-count {
  margin-top: 2px;
  font-weight: normal;
  font-size: 15px;
}
.was-Invalidated,
.was-Invalidated:focus {
  background-color: #f7d7da;
  border: 1px solid #c5cdcf;
}
</style>
